import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const EnlargeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Enlarge",
    children: /*#__PURE__*/_jsx("path", {
      d: "M30 4v10.09c0 1.08-.87 1.95-1.95 1.95s-1.95-.87-1.95-1.95V8.52l-5.62 5.62c-.04.07-.1.13-.16.19L8.63 26.02h5.44c1.07.01 1.95.89 1.95 1.97 0 .54-.22 1.02-.57 1.38-.36.35-.85.57-1.38.57H3.97c-.55 0-1.05-.23-1.41-.6-.34-.36-.56-.84-.56-1.37v-10.1c0-1.08.87-1.95 1.95-1.95s1.95.87 1.95 1.95v5.58l11.8-11.78s.09-.08.14-.11l5.61-5.59h-5.44c-1.08 0-1.95-.88-1.95-1.96 0-.54.22-1.03.57-1.38.36-.35.84-.57 1.38-.57h10.05C29.13 2.06 30 2.93 30 4"
    })
  }));
};